import { render, staticRenderFns } from "./FormThanks.vue?vue&type=template&id=57597656&scoped=true&"
import script from "./FormThanks.vue?vue&type=script&lang=js&"
export * from "./FormThanks.vue?vue&type=script&lang=js&"
import style0 from "./FormThanks.vue?vue&type=style&index=0&id=57597656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57597656",
  null
  
)

export default component.exports